
import Vue from 'vue';
import Component from 'vue-class-component';
import SectionLayout from '../../SectionLayout.vue';
import { i18nModule } from '@/utils/store-acessor';
import { CategoryModel } from '@/models/category.model';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import CategoryCard from '@/components/Shared/CategoryCard.vue';
import { getCategories } from '@/models/category.model';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    CategoryCard,
    SectionLayout
  }
})
export default class HomeCategories extends Vue {
  @i18nModule.Getter('locale') selected!: LocaleSelectorType;
  showOnlyActives: boolean = true;
  onuCategories!: any[];

  created() {
    if (this.selected.value === 'en') {
      this.onuCategories = getCategories('en');
    } else {
      this.onuCategories = getCategories('br');
    }
  }

  @Watch('selected')
  onLocaleSelected(v: LocaleSelectorType) {
    if (v.value === 'en') {
      this.onuCategories = getCategories('en');
    } else {
      this.onuCategories = getCategories('br');
    }
  }

  get largeScreen() {
    return this.$vuetify.breakpoint.xlOnly ? 'large-size' : 'medium-size';
  }
}
